import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper";
import "./styles.css";
import { Recepcion } from "./Slides/Recepcion";
import { SalaDeReuniones } from "./Slides/SalaDeReuniones";
import { ChillRelax } from "./Slides/ChillRelax";
import { Cocina } from "./Slides/Cocina";
import { OficinasPrivadas } from "./Slides/OficinasPrivadas";
import { CoWorking } from "./Slides/CoWorking";

export const SliderEspacios = () => {
  return (
    <div className="navigation-wrapper-cocina">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        loop={true}
        spaceBetween={50}
        slidesPerView={1}
      >
        <SwiperSlide>
          <Recepcion />
        </SwiperSlide>
        <SwiperSlide>
          <SalaDeReuniones />
        </SwiperSlide>
        <SwiperSlide>
          <ChillRelax />
        </SwiperSlide>
        <SwiperSlide>
          <Cocina />
        </SwiperSlide>
        <SwiperSlide>
          <OficinasPrivadas />
        </SwiperSlide>
        <SwiperSlide>
          <CoWorking />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};